import { render, staticRenderFns } from "./PointRule.vue?vue&type=template&id=54d2d49a&scoped=true"
import script from "./PointRule.vue?vue&type=script&lang=js"
export * from "./PointRule.vue?vue&type=script&lang=js"
import style0 from "./PointRule.vue?vue&type=style&index=0&id=54d2d49a&prod&lang=css"
import style1 from "./PointRule.vue?vue&type=style&index=1&id=54d2d49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2d49a",
  null
  
)

export default component.exports